<template>
  <div>
    <q-btn class="capitalize ctrl-button right q-ml-md" color="primary" label="Logs" @click="fetchLogs()" icon="mdi-history" />

    <q-modal v-model="open" persistent transition-show="slide-up" transition-hide="slide-down" :maximized="true" class="q-pa-xl">
      <q-modal-layout>
        <q-toolbar class="bg-primary text-white">
          <q-toolbar-title>
            Spare Parts Logs
          </q-toolbar-title>
          <q-btn flat icon="mdi-close" @click="open = false" />
        </q-toolbar>

        <div class="row">
          <div class="col-6 q-pa-md">
            <div class="full-width">
              <q-select
                class="q-mb-xs"
                multiple
                @input="fetchLogs"
                v-model="filters.level"
                :options="levelOptions"
                :float-label="getString('module.logs.list.table.column.level')"/>
            </div>
            <q-table :data="logs" :pagination.sync="pagination" :columns="[
              { name: 'message', label: getString(null, 'Message', 'Bericht'), field: 'message', align: 'left' },
              { name: 'created_at', label: getString(null, 'Date', 'Datum'), field: 'created_at', align: 'left' },
            ]" row-key="id">
            <q-tr slot="body" slot-scope="props" :props="props" @click.native="rowClick(props.row)" class="cursor-pointer" :class="{ 'ctrl-row-select': selectedRow && selectedRow.id === props.row.id }">
              <q-td key="message" :props="props">
                {{ props.row.message }}
              </q-td>
              <q-td key="created_at" :props="props">
                {{ formatDate(props.row.created_at) }}
              </q-td>
            </q-tr>
            </q-table>
          </div>
          <div class="col-6 q-pa-md">
            <json-viewer :json="selectedRow ? selectedRow : {}" />
          </div>
        </div>
      </q-modal-layout>
    </q-modal>
  </div>
</template>

<script>
import moment from 'moment';
import getString from '@/helpers/GetStrings';
import JsonViewer from '../../../../components/JsonViewer.vue';

export default {
  components: {
    JsonViewer,
  },
  name: 'SparePartsLogsModal',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logs: [],
      filters: {
        level: [],
      },
      levelOptions: [],
      selectedRow: null,
      pagination: {
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: 10
      }
    };
  },
  methods: {
    getString,

    rowClick(row) {
      this.selectedRow = row;
    },

    formatDate(date) {
      return moment(date).format('DD-MM-YYYY hh:mm');
    },

    fetchLogLevels() {
      this.axios.get(`spareparts/${this.$route.params.id}/logs/levels`)
        .then((response) => {
          this.levelOptions = response.data.levels.map(level => ({
            label: level.level,
            value: level.level,
          }));
        });
    },

    fetchLogs() {
      let query = `spareparts/${this.$route.params.id}/logs`;
      if (this.filters.level.length > 0) {
        query += `?level=${this.filters.level.join(',')}`;
      }
      this.axios.get(query)
        .then((response) => {
          this.logs = response.data.logs;
          this.open = true;
        })
        .catch(() => {
          this.$q.notify({
            message: 'Error fetching logs',
            color: 'negative',
          });
        });
    },
  },

  mounted() {
    this.fetchLogLevels();
  },
};
</script>

<style lang="stylus" scoped>

.ctrl-row-select > td
  border-bottom 1px solid rgba(0,0,0,.04) !important
  border-top 1px solid rgba(0,0,0,.04) !important
  color $ctrl-row-select-text !important
  background-color $ctrl-row-select-bg !important
</style>
